import type { BlocksContent } from '@strapi/blocks-react-renderer';

type InlineNode = { type: string; text?: string; children?: InlineNode[] };

/** Достаёт текст из inline-узла (text или link с вложенными text-узлами). */
export function inlineNodeText(node: InlineNode): string {
  if (node.type === 'text') return node.text ?? '';
  return node.children?.map(inlineNodeText).join('') ?? '';
}

/**
 * Извлекает чистый текст из BlocksContent (Strapi rich text) — без служебных
 * маркеров вроде `=== `, `Image: ...`, `- `, `Quote:`, которые добавляет
 * parseBlockTypeToString. Подходит для meta description, JSON-LD description.
 */
export function getPlainText(blocks: BlocksContent): string {
  return (blocks ?? [])
    .map((block) => {
      switch (block.type) {
        case 'paragraph':
        case 'heading':
        case 'quote':
          return block.children?.map(inlineNodeText).join(' ') ?? '';
        case 'list':
          return (
            block.children
              ?.map((item) => item.children?.map(inlineNodeText).join(' '))
              .filter(Boolean)
              .join('. ') ?? ''
          );
        default:
          // image, code — в текстовое описание не идут
          return '';
      }
    })
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Обрезает текст до max символов по границе слова, добавляя `…`.
 * По умолчанию 160 — оптимум для meta description.
 */
export function truncate(text: string, max = 160): string {
  const t = (text ?? '').trim();
  if (t.length <= max) return t;
  const cut = t.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(' ');
  const safe = lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut;
  return `${safe.trim()}…`;
}
